module.exports = "https://static.wanderu.com/ui-react/_next/static/media/sliders.4af81418.svg";